import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';
import logo from '../assets/LOGO.png';

function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  const links = [
    { name: 'Home', to: '/' },
    { name: 'About', to: '/about' },
    { name: 'Projects', to: '/projects' },
    { name: 'Careers', to: '/careers' },
    { name: 'Contact', to: '/contact' },
  ];

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 50;
      setScrolled(isScrolled);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <header className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="navbar-container">
        <Link to="/" className="logo-link" onClick={() => setOpen(false)}>
          <img src={logo} alt="Studio 13 Logo" className="logo" />
        </Link>

        <nav className={`nav-links ${open ? 'open' : ''}`}>
          {links.map(link => (
            <Link 
              key={link.name} 
              to={link.to} 
              className={`nav-link ${isActive(link.to) ? 'active' : ''}`}
              onClick={() => setOpen(false)}
            >
              {link.name}
            </Link>
          ))}
        </nav>

        <div className="hamburger" onClick={() => setOpen(!open)}>
          <span className={`hamburger-line ${open ? 'open' : ''}`}></span>
          <span className={`hamburger-line ${open ? 'open' : ''}`}></span>
          <span className={`hamburger-line ${open ? 'open' : ''}`}></span>
        </div>
      </div>
    </header>
  );
}

export default Navbar;
